/**
 * Widget settings API — per-tenant configuration for the 4 embeddable widgets.
 * Each widget stores: { mode: "active"|"test"|"passive", config: {...} }
 */
import { api } from "./api";

export const WIDGET_KEYS = ["size_table", "find_my_size", "model_info", "fit_info"];

export async function fetchAllWidgetSettings() {
    const { data } = await api.get("/widget-settings");
    return data;
}

export async function updateWidgetSettings(key, body) {
    const { data } = await api.put(`/widget-settings/${key}`, body);
    return data;
}
